export default "__VITE_ASSET__DvD3IMdp__"